import { CurrencyUtils } from '../../common/CurrencyUtils';
import { Commission } from '../../domain/models/Commission';

export const getCommissionValue = (com: Commission) => {
    return com.com_fija ?
        CurrencyUtils.moneyFormat(com.comision) :
        `${com.comision.toFixed(2)} %`;

}
